/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SortingModel
 */
export interface SortingModel {
    /**
     * 
     * @type {string}
     * @memberof SortingModel
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SortingModel
     */
    selected?: boolean;
}

/**
 * Check if a given object implements the SortingModel interface.
 */
export function instanceOfSortingModel(value: object): boolean {
    return true;
}

export function SortingModelFromJSON(json: any): SortingModel {
    return SortingModelFromJSONTyped(json, false);
}

export function SortingModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortingModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'selected': json['selected'] == null ? undefined : json['selected'],
    };
}

export function SortingModelToJSON(value?: SortingModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'selected': value['selected'],
    };
}

